export const positionClasses = {
  'top-right': '-top-1 -right-1',
  'top-left': '-top-1 -left-1',
  'bottom-right': '-bottom-1 -right-1',
  'bottom-left': '-bottom-1 -left-1'
};

export const sizeClasses = {
  small: 'h-3 min-w-3 w-fit',
  medium: 'h-4 min-w-4 w-fit',
  large: 'h-5 min-w-5 w-fit'
};
